import React, { useState } from 'react';
import { AppBar, Container, Toolbar, Grid, Paper, CssBaseline, makeStyles } from '@material-ui/core';
import SendResultsWidget from './CopyResultsWidget/SendResultsWidget';
import KixieNetworkTestWidget from './NetworkTestWidget/KixieNetworkTestWidget';
import ResultWidget from './ResultWidget/ResultWidget';

// TODO: Move Start button to center
// TODO: Add email/name modal to results report
// TODO: Add Port/IP Scanner Test

const useStyles = makeStyles({
  container: {
    marginTop: '2em',
  },
  paper: {
    padding: '1.5em',
  },
});

function App() {
  const classes = useStyles();
  const [results, setResults] = useState();

  /** TODO: Add TURN creds to retrieve exhaustive networking test
   * async function getTURNCredentials() {
    const iceServers: RTCIceServer[] = await fetch('app/turn-credentials')
      .then((res) => res.json())
      .then((res) => res.iceServers);

    return iceServers;
  }
  **/

  async function getVoiceToken() {
    const token: string = await fetch('app/token')
      .then((res) => res.json())
      .then((res) => res.token);

    return token;
  }

  return (
    <div>
      <CssBaseline />
      <AppBar position="static">
        <Toolbar>
          <a href="https://kixie.com" target="_blank" rel="noopener noreferrer">
            <img src="kixie-logo-dark.png" style={{ maxHeight: '60px' }} alt="KixieLogo"></img>
          </a>
        </Toolbar>
      </AppBar>
      <Container className={classes.container}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper className={classes.paper} elevation={3}>
              <KixieNetworkTestWidget
                getVoiceToken={getVoiceToken}
                // eslint-disable-next-line no-shadow
                onComplete={(results) => {
                  setResults(results);
                }}
                regions={['roaming']}
              />
            </Paper>
          </Grid>
          <Grid container justify="center">
            <SendResultsWidget results={results} />
          </Grid>
          <Grid item xs={12}>
            <Paper elevation={3}>
              <ResultWidget results={results} />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default App;
